import { get } from 'lodash/fp';
import { createAndSendButtonSubmissionEventWithEventName } from '../../../analytics/commonAnalytics';
import AnalyticsConstants from '../../../analytics/constants';

import setDimensions from './setDimensions';
import setEstimateMode from './setEstimateMode';
import getPLPUrl from '../../getPLPUrl';

export default itemId => (dispatch, getState) => {
  const { estimateBuilder } = getState();

  const item = get(`entities.items.byId.${itemId}`)(estimateBuilder);
  const designId = get('designId')(item);
  const design = get(`entities.estimates.byId.${designId}`)(estimateBuilder);

  setEstimateMode(design, item);
  setDimensions(item);

  createAndSendButtonSubmissionEventWithEventName(
    window.globalConfig.siteId,
    AnalyticsConstants.EventNames.DesignShopProducts,
  );

  window.location.href = dispatch(getPLPUrl(itemId));
};

